var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMasterCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.152 29.306h14.159V3.748H19.152v25.558z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.05 16.527a16.25 16.25 0 016.18-12.779 16.065 16.065 0 00-10-3.475C7.296.273.05 7.55.05 16.527s7.245 16.254 16.18 16.254c3.776 0 7.248-1.298 10-3.475a16.251 16.251 0 01-6.18-12.779z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.905 26.599v-.63h-.164l-.188.433-.189-.434H51.2v.63h.116v-.475l.177.41h.12l.177-.41v.476h.115zm-1.038 0v-.523h.21v-.107h-.535v.107h.21v.523h.115zm1.544-10.072c0 8.976-7.245 16.254-16.18 16.254a16.064 16.064 0 01-10-3.475 16.251 16.251 0 006.18-12.78c0-5.184-2.417-9.802-6.18-12.778a16.064 16.064 0 0110-3.475c8.935 0 16.18 7.277 16.18 16.254z",
    fill: "#F79E1B"
  })));
}

export default SvgMasterCard;